import { useTranslation } from 'react-i18next';
import { Share, SquarePlus } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '@repo/ui/src/components/ui/dialog';
import { useInstallHelpStore } from '../stores/installHelpStore';

/**
 * iOS-only fallback for the "Cài ứng dụng" row: Safari has no install API,
 * so the row cannot open a native prompt the way Android does — the honest
 * substitute is the two taps Apple actually requires, spelled out.
 */
export function InstallHelpDialog() {
  const { t } = useTranslation('common');
  const open = useInstallHelpStore((s) => s.open);
  const setOpen = useInstallHelpStore((s) => s.setOpen);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[380px]">
        <DialogHeader>
          <DialogTitle>{t('install.helpTitle')}</DialogTitle>
          <DialogDescription>{t('install.helpIntro')}</DialogDescription>
        </DialogHeader>
        <ol className="space-y-3 text-sm text-surface-700">
          <li className="flex items-center gap-3">
            <span className="flex size-[32px] shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-700">
              <Share className="size-4" strokeWidth={1.8} />
            </span>
            {t('install.helpStep1')}
          </li>
          <li className="flex items-center gap-3">
            <span className="flex size-[32px] shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-700">
              <SquarePlus className="size-4" strokeWidth={1.8} />
            </span>
            {t('install.helpStep2')}
          </li>
        </ol>
      </DialogContent>
    </Dialog>
  );
}
